










export default
  data:() ->
    is_scroll: false

  created: () ->
    $(() =>
      if (window.innerWidth < 798)
        window.anime = lottie.loadAnimation({
          container: document.getElementById('anime')
          renderer: 'svg'
          loop: false
          autoplay: false
          path: '/assets/js/sp/data.json'
        })
      else
        window.anime = lottie.loadAnimation({
          container: document.getElementById('anime')
          renderer: 'svg'
          loop: false
          autoplay: false
          path: '/assets/js/pc/data.json'
        })

      isAnime = false
      point = 0
      befScrollPos = 100
      spanValue = 10
      maxFrame = 0
      $('#scroll_base').scrollTop(100)
      $('#scroll_base').scroll((e) =>
#        @is_scroll = true
        if (isAnime)
          $('#scroll_base').scrollTop(100)
          befScrollPos = 100
          return

        obj = @
        if point == 1
          @is_scroll = true
          isAnime = true
          setTimeout(() ->
            isAnime = false
            $('#scroll_base').scrollTop(100)
            befScrollPos = 100
            obj.$emit('whiteout')
          , 8000)
          window.anime.playSegments([0, 290], true)
        point++
      )

      $(window).keypress((e) =>
        if e.charCode == 113
          @$emit('whiteout')
      )
    )
  methods: {
    key_press: (e) ->
      console.log e
  }
